import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { X } from 'lucide-react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix para los iconos de Leaflet en React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const MapModal = ({ isOpen, onClose, lotes }) => {
  // Cerrar modal con ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Centro de Uruguay (coordenadas aproximadas)
  const uruguayCenter = [-32.5, -55.8];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      {/* Modal */}
      <div className="relative w-full h-full md:w-[95%] md:h-[90%] bg-white rounded-none md:rounded-2xl shadow-2xl overflow-hidden">

        {/* Header del modal */}
        <div className="absolute top-0 left-0 right-0 z-[1000] bg-gradient-to-r from-green-600 to-green-500 p-4 md:p-6 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center gap-3">
                🗺️ Vista de Mapa
              </h2>
              <p className="text-white/90 text-sm md:text-base mt-1">
                <span className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full font-semibold">
                  {lotes.length}
                </span>
                {' '}lotes en el mapa
              </p>
            </div>
            <button
              onClick={onClose}
              className="bg-white/20 hover:bg-white/30 text-white p-3 rounded-xl transition-all duration-300 hover:rotate-90"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Mapa */}
        <div className="w-full h-full pt-20 md:pt-24">
          <MapContainer
            center={uruguayCenter}
            zoom={7}
            className="w-full h-full"
            scrollWheelZoom={true}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {/* Marcadores de lotes */}
            {lotes.map((lote) => {
              if (!lote.latitude || !lote.longitude) return null;

              return (
                <Marker
                  key={lote.numero_lote}
                  position={[lote.latitude, lote.longitude]}
                >
                  <Popup>
                    <div className="p-2 min-w-[250px]">
                      {/* Header del popup */}
                      <div className="bg-gradient-to-r from-green-600 to-green-500 text-white px-3 py-2 rounded-lg mb-3 -mx-2 -mt-2">
                        <h3 className="font-bold text-lg">Lote #{lote.numero_lote}</h3>
                        <p className="text-xs text-white/80">Inspección #{lote.numero_lote}</p>
                      </div>

                      {/* Datos del lote */}
                      <div className="space-y-2 text-sm">
                        <div className="flex justify-between border-b pb-1">
                          <span className="text-gray-500 font-semibold">Cabezas:</span>
                          <span className="font-bold text-gray-900">{lote.cabezas}</span>
                        </div>
                        <div className="flex justify-between border-b pb-1">
                          <span className="text-gray-500 font-semibold">Raza:</span>
                          <span className="font-bold text-gray-900 text-xs">{lote.raza}</span>
                        </div>
                        <div className="flex justify-between border-b pb-1">
                          <span className="text-gray-500 font-semibold">Depto:</span>
                          <span className="font-bold text-gray-900 text-xs">{lote.departamento}</span>
                        </div>
                        <div className="flex justify-between border-b pb-1">
                          <span className="text-gray-500 font-semibold">Escritorio:</span>
                          <span className="font-bold text-gray-900 text-xs">{lote.escritorio}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-500 font-semibold">Preoferta:</span>
                          <span className={`font-bold text-xs ${lote.preoferta === 'Acepta Preoferta'
                            ? 'text-green-700'
                            : 'text-gray-400'
                            }`}>
                            {lote.preoferta === 'Acepta Preoferta' ? 'SÍ' : 'NO'}
                          </span>
                        </div>
                      </div>

                      {/* Botón Ver detalles */}
                      <button
                        onClick={() => window.location.href = `/web/lotes/${lote.id}`}
                        className="w-full mt-3 bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg font-bold text-sm transition-colors"
                      >
                        Ver detalles
                      </button>
                    </div>
                  </Popup>
                </Marker>
              );
            })}
          </MapContainer>
        </div>
      </div>
    </div>
  );
};

export default MapModal;
